import React from "react";
import AboutHero from "../components/common/AboutHero";
import Recete3 from "../assets/images/recete3.jpg";
import "../assets/styles/kvkk.scss";
import ttb from "../assets/images/ttb.png";
import { helsinkiBildirgesi } from "../data/helsinkiBildirgesi";
import { ttbBildirgesi } from "../data/ttbBildirgesi";
import wma from "../assets/images/wma.png";

const HastaHaklariBildirgesiPage: React.FC = () => {
  return (
    <>
      <AboutHero
        image={Recete3}
        kicker="Türk Tabipleri Birliği"
        title="Hasta Hakları Bildirgesi"
        description={`4-5 Nisan 2008 tarihlerinde 'TTB Etik Bildirgeler Çalıştayı'nda geliştirilmiş,
20 Haziran 2009 tarihinde 'TTB II. Etik Bildirgeler Çalıştayı'nda güncellenmiş,
26 Haziran 2009 tarihinde TTB 58. Büyük Kongre'sinde kabul edilmiştir.`}
        overlayColor="#2cadd2"
        overlayOpacity={0.72}
        accentColor="#e30613"
        textColor="#2b2b2b"
        focus="center center"
        align="center"
        desktopHeight={460}
        tabletHeight={380}
        mobileHeight={320}
      />
      <section className="legal-page">
        <div className="lg-container">
          <div className="lg-hero">
            <div className="lg-hero__inner">
              <main className="lg-content">
                <article className="lg-section">
                  <h3 className="lg-section-title">Bildirge</h3>
                  <div style={{ display: 'flex', gap: '30px', alignItems: 'center', flexDirection: 'row', flexWrap: 'wrap' }}>
                    <div style={{ flex: '1 1 300px', minWidth: 0 }}>
                      {ttbBildirgesi.split('\n\n').map((paragraph, index) => (
                        <p key={index} className="lg-p" style={{ marginBottom: '15px', whiteSpace: 'pre-wrap' }}>
                          {paragraph}
                        </p>
                      ))}
                    </div>
                    <div style={{ flexShrink: 0, width: '200px', margin: '0 auto' }}>
                      <img src={ttb} alt="Türk Tabipleri Birliği" style={{ width: '100%', height: 'auto' }} />
                    </div>
                  </div>
                </article>
              </main>
            </div>
          </div>
        </div>
      </section>

      <AboutHero
        image={Recete3}
        kicker="Dünya Tabipleri Birliği (World Medical Association)"
        title="Hasta Hakları Bildirgesi"
        description=""
        overlayColor="#2cadd2"
        overlayOpacity={0.72}
        accentColor="#e30613"
        textColor="#2b2b2b"
        focus="center center"
        align="center"
        desktopHeight={300}
        tabletHeight={250}
        mobileHeight={200}
      />

      <section className="legal-page">
        <div className="lg-container">
          <div className="lg-hero">
            <div className="lg-hero__inner">
              <main className="lg-content">
                <article className="lg-section" style={{ marginTop: '60px' }}>
                  <div style={{ display: 'flex', gap: '40px', alignItems: 'flex-start', flexDirection: 'row', flexWrap: 'wrap' }}>
                    <div style={{ flexShrink: 0, width: '150px', margin: '0 auto', order: 1 }}>
                      <img src={wma} alt="World Medical Association" style={{ width: '100%', height: 'auto' }} />
                    </div>
                    <div style={{ flex: '1 1 300px', minWidth: 0, order: 2 }}>
                      <h3 className="lg-section-title">Bildirge</h3>
                      {helsinkiBildirgesi.split('\n\n').slice(1).map((paragraph, index) => (
                        <p key={index} className="lg-p" style={{ fontSize: '14px', lineHeight: '1.8', marginBottom: '15px', whiteSpace: 'pre-wrap' }}>
                          {paragraph}
                        </p>
                      ))}
                    </div>
                  </div>
                </article>
              </main>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HastaHaklariBildirgesiPage;
